export namespace UtilsConst {
  export const invalidIndex = -1
  export const invalidNumber = -1

  /**
   * Matches all non-printable or invisible characters, excluding '\n', '\r', '\t', '\b', and '\f'.
   *
   * Includes:
   * - ASCII control characters U+0000–U+001F and U+007F (except newline, carriage return, tab, backspace, form feed)
   * - Soft hyphen (U+00AD)
   * - Common zero-width and formatting characters:
   *   - U+200B–U+200D (Zero Width Space, Non-Joiner, Joiner)
   *   - U+200E–U+200F (Left-to-Right / Right-to-Left Mark)
   *   - U+2060 (Word Joiner)
   *   - U+2061–U+2064 (Invisible math/word operators)
   *   - U+2066–U+2069 (Bidirectional isolate controls)
   *   - U+FEFF (Byte Order Mark)
   *
   * Purpose:
   *   Used for sanitizing strings by removing control and invisible characters
   *   that may interfere with text rendering, search, or copy/paste operations.
   */
  // For replacing globally
  export const nonPrintableCopyRegexGlobal = /[\x00-\x07\x0B\x0E-\x1F\x7F\u00AD\u200B-\u200D\u2060\u2061-\u2064\u2066-\u2069\uFEFF\u200E\u200F]/g
  // For checking if a string *contains* such chars (non-global for safe `.test`)
  export const nonPrintableCopyRegex = /[\x00-\x07\x0B\x0E-\x1F\x7F\u00AD\u200B-\u200D\u2060\u2061-\u2064\u2066-\u2069\uFEFF\u200E\u200F]/

  export enum RequestHeaders {
    CustomHeaderKeyAppName = 'X-Jig-App',
    CustomHeaderKeyTenantId = 'X-Jig-Tenant-Id',
  }

  export enum HTTPAction {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
  }

  export enum AvatarColor {
    dune_100 = 'dune-100',
    rain_700 = 'rain-700',
    info_500 = 'info-500',
    info_300 = 'info-300',
  }

  export const userAvatarColors = [AvatarColor.dune_100, AvatarColor.rain_700, AvatarColor.info_500, AvatarColor.info_300]

  export const searchEvents: Record<string, string> = {
    onSearch: 'on-search',
    onSearchChange: 'on-search-change',
    onSearchReset: 'on-search-reset',
  }

  export const defaultUsersJigsPerPage: number = 250
  export const defaultJigStaffJigsPerPage: number = 500
}
